import React from "react";

const footerStyle = {
  backgroundColor: "#eee",
  // borderTop: "1px solid #E7E7E7",
  textAlign: "center",
  left: "0",
  bottom: "0",
  paddingTop: "20px",
  paddingBottom: "20px",
  width: "100%",
  position: "absolute"
};

export default function Footer({ children }) {
  return (
    <div>
      <div style={footerStyle}>{children}</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer.js